<template>
  <div>
    <vxe-card size="mini" width="100%">
      <div slot="title">
        <vxe-button content="tab.details" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </div>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="refresh(customer.id)"/>
        <vxe-button content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
      </template>
      <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="customer" :rules="rules" :wrapper-col="wrapperCol">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.no')" prop="no">
              <vxe-input v-model="customer.no" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.name')" prop="name">
              <vxe-input v-model="customer.name" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.mnemonicCode')">
              <vxe-input v-model="customer.mnemonicCode" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.shortName')">
              <vxe-input v-model="customer.shortName" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.storer')">
              <vxe-select v-model="storerIds" :options="storers" multiple style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.customerCategory')">
              <vxe-select v-model="customer.classification.id" :options="classifications" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.regions')">
              <vxe-select v-model="customer.region.id" :options="regions" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.dataSource')">
              <vxe-select v-model="customer.dataSource" :options="dataSources" disabled style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.turnoverMode')">
              <vxe-select v-model="customer.turnoverMode" :options="turnoverModes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.numberOfLot')">
              <vxe-number-input v-model="customer.numberOfLot" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.separationOfLabel')">
              <vxe-number-input v-model="customer.separationOfLabel" :min="0" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col span="6">
            <a-form-model-item :label="$t('business.label.pickupMode')" prop="pickupMode">
              <vxe-select v-model="customer.pickupMode.id" :options="pickupModes" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col span="3">
            <a-form-model-item :label="$t('business.label.available')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="customer.available" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col span="3">
            <a-form-model-item :label="$t('business.label.inner')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="customer.inner" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col v-if="type===1" span="3">
            <a-form-model-item :label="$t('business.label.autoAccepting')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="customer.autoAccepting" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col v-if="type===1" span="3">
            <a-form-model-item :label="$t('business.label.autoPutaway')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="customer.autoPutaway" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col v-if="type===2" span="3">
            <a-form-model-item :label="$t('business.label.autoPrint')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="customer.autoPrint" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col v-if="type===2" span="3">
            <a-form-model-item :label="$t('business.label.mergeOrder')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="customer.mergeOrder" size="mini"/>
            </a-form-model-item>
          </a-col>
          <a-col span="3">
            <a-form-model-item :label="$t('business.label.reserveOnly')" :label-col="wrapperCol" :wrapper-col="labelCol">
              <vxe-switch v-model="customer.reserveOnly" size="mini"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-card>
    <address-detail ref="addressDetail" @change="onAddressChange"/>
  </div>
</template>
<script>
import Vue from 'vue'
import { ENTERPRISE } from '@/store/mutation-types'
import { findOne, save } from '@/api/Api'
import { Customer } from '@/api/dto/common/Customer'
import AddressDetail from '@/views/basedata/address/AddressDetail.vue'

export default {
  name: 'CustomerDetail',
  components: { AddressDetail },
  data() {
    return {
      loading: false,
      enterprise: Vue.ls.get(ENTERPRISE),
      customer: new Customer(),
      storerIds: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        no: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        name: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        pickupMode: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  props: {
    type: {
      default: null
    },
    classifications: {
      type: Array,
      default: []
    },
    regions: {
      type: Array,
      default: []
    },
    dataSources: {
      type: Array,
      default: []
    },
    turnoverModes: {
      type: Array,
      default: []
    },
    pickupModes: {
      type: Array,
      default: []
    },
    storers: {
      type: Array,
      default: []
    }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    onAddressChange(value) {
      this.customer.address = value
    },
    refresh(id, copy) {
      this.loading = true
      findOne('customerFactory', { id: id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.customer = new Customer(res.result)
          this.storerIds = res.result.storers.map(item => item.id)
          if (!this.customer.address.isNew()) this.$refs.addressDetail.refresh(this.customer.address.id)
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.customer = new Customer()
      this.customer.available = true
      this.customer.approved = true
      this.customer.dataSource = 4
      this.customer.upstream = this.type === 1
      this.customer.downstream = this.type === 2
      this.storerIds = []
    },
    save() {
      this.$refs.form.validate((success) => {
        if (success) {
          this.loading = true
          const customer = this.customer.toJSONObject()
          customer.enterprise = this.enterprise
          customer.storers = this.storerIds ? this.storerIds.map(item => {
            return { id: item }
          }) : []
          save('customerPersister', customer).then(res => {
            if (res.success) {
              this.customer = new Customer(res.result)
              this.storerIds = res.result.storers.map(item => item.id)
              if (!this.customer.address.isNew()) this.$refs.addressDetail.refresh(this.customer.address.id)
              this.$message.success(this.$t('message.saveSuccess'))
            }
          }).finally(() => this.loading = false)
        }
      })
    }
  }
}
</script>